import React from 'react';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';

const ServiceModal = ({ service, onClose }) => {
  if (!service) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/50 backdrop-blur-sm">
      <div className="bg-background rounded-xl max-w-4xl w-full max-h-[90vh] overflow-y-auto shadow-2xl">
        <div className="sticky top-0 bg-background border-b border-border px-4 md:px-6 py-4 flex items-center justify-between z-10">
          <h2 className="text-xl md:text-2xl font-bold text-foreground line-clamp-1">
            {service?.title}
          </h2>
          <button
            onClick={onClose}
            className="w-8 h-8 md:w-10 md:h-10 rounded-lg hover:bg-muted flex items-center justify-center transition-colors flex-shrink-0"
            aria-label="Close modal"
          >
            <Icon name="X" size={24} />
          </button>
        </div>

        <div className="p-4 md:p-6 lg:p-8 space-y-6 md:space-y-8">
          <div className="relative h-64 md:h-80 lg:h-96 rounded-xl overflow-hidden">
            <Image
              src={service?.image}
              alt={service?.imageAlt}
              className="w-full h-full object-cover"
            />
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-6">
            <div className="bg-card rounded-lg p-4 md:p-6 text-center">
              <Icon name="Target" size={32} className="mx-auto mb-3 text-primary" />
              <div className="text-2xl md:text-3xl font-bold text-foreground mb-1">
                {service?.project_count || service?.projectCount}+
              </div>
              <div className="text-xs md:text-sm text-muted-foreground">Projects Delivered</div>
            </div>
            <div className="bg-card rounded-lg p-4 md:p-6 text-center">
              <Icon name="Users" size={32} className="mx-auto mb-3 text-accent" />
              <div className="text-2xl md:text-3xl font-bold text-foreground mb-1">
                {service?.client_count || service?.clientCount}+
              </div>
              <div className="text-xs md:text-sm text-muted-foreground">Satisfied Clients</div>
            </div>
            <div className="bg-card rounded-lg p-4 md:p-6 text-center">
              <Icon name="Star" size={32} className="mx-auto mb-3 text-warning" />
              <div className="text-2xl md:text-3xl font-bold text-foreground mb-1">
                {service?.rating}
              </div>
              <div className="text-xs md:text-sm text-muted-foreground">Client Rating</div>
            </div>
          </div>

          <div>
            <h3 className="text-lg md:text-xl font-bold text-foreground mb-3 md:mb-4">
              Service Overview
            </h3>
            <p className="text-sm md:text-base text-muted-foreground leading-relaxed">
              {service?.detailed_description || service?.detailedDescription}
            </p>
          </div>

          <div>
            <h3 className="text-lg md:text-xl font-bold text-foreground mb-3 md:mb-4">
              Key Capabilities
            </h3>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-3 md:gap-4">
              {service?.capabilities?.map((capability, index) => (
                <div key={index} className="flex items-start gap-3 bg-card rounded-lg p-3 md:p-4">
                  <Icon name="CheckCircle2" size={20} className="text-success flex-shrink-0 mt-0.5" />
                  <span className="text-sm md:text-base text-foreground">{capability}</span>
                </div>
              ))}
            </div>
          </div>

          <div>
            <h3 className="text-lg md:text-xl font-bold text-foreground mb-3 md:mb-4">
              Implementation Process
            </h3>
            <div className="space-y-3 md:space-y-4">
              {service?.process?.map((step, index) => (
                <div key={index} className="flex gap-3 md:gap-4">
                  <div className="w-8 h-8 md:w-10 md:h-10 rounded-full bg-primary text-white flex items-center justify-center font-bold text-sm md:text-base flex-shrink-0">
                    {index + 1}
                  </div>
                  <div className="flex-grow min-w-0">
                    <h4 className="font-semibold text-foreground mb-1 text-sm md:text-base">
                      {step?.title}
                    </h4>
                    <p className="text-xs md:text-sm text-muted-foreground">
                      {step?.description}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div className="flex flex-col sm:flex-row gap-3 md:gap-4 pt-4 md:pt-6 border-t border-border">
            <button className="flex-1 px-6 py-3 bg-primary hover:bg-primary/90 text-white rounded-lg font-semibold transition-all duration-200 flex items-center justify-center gap-2 text-sm md:text-base">
              <Icon name="Calendar" size={20} />
              Schedule Consultation
            </button>
            <button className="flex-1 px-6 py-3 bg-accent hover:bg-accent/90 text-white rounded-lg font-semibold transition-all duration-200 flex items-center justify-center gap-2 text-sm md:text-base">
              <Icon name="Download" size={20} />
              Download Details
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ServiceModal;